import createIcon from '../../createIcon';

/**
 * @component @name DeviceUnknown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMUg3QzUuOSAxIDUgMS45IDUgM1YyMUM1IDIyLjEgNS45IDIzIDcgMjNIMTdDMTguMSAyMyAxOSAyMi4xIDE5IDIxVjNDMTkgMS45IDE4LjEgMSAxNyAxWk0xNyAxOUg3VjVIMTdWMTlaTTEyIDYuNzJDMTAuMDQgNi43MiA4LjUgOC4yNCA4LjUgMTAuMTlIMTAuMjVDMTAuMjUgOS4yNiAxMS4wNyA4LjQ0IDEyIDguNDRDMTIuOTMgOC40NCAxMy43NSA5LjI2IDEzLjc1IDEwLjE5QzEzLjc1IDExLjk0IDExLjEyIDExLjc2IDExLjEyIDE0LjY0SDEyLjg4QzEyLjg4IDEyLjY4IDE1LjUgMTIuNDUgMTUuNSAxMC4xOUMxNS41IDguMjMgMTMuOTYgNi43MiAxMiA2LjcyWk0xMS4xMiAxNS41MkgxMi44OFYxNy4yOEgxMS4xMlYxNS41MloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DeviceUnknown = createIcon('DeviceUnknown', [
  [
    'path',
    {
      d: 'M17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM17 19H7V5H17V19ZM12 6.72C10.04 6.72 8.5 8.24 8.5 10.19H10.25C10.25 9.26 11.07 8.44 12 8.44C12.93 8.44 13.75 9.26 13.75 10.19C13.75 11.94 11.12 11.76 11.12 14.64H12.88C12.88 12.68 15.5 12.45 15.5 10.19C15.5 8.23 13.96 6.72 12 6.72ZM11.12 15.52H12.88V17.28H11.12V15.52Z',
      key: '1cysku',
    },
  ],
]);

export default DeviceUnknown;
